import dayjs from "dayjs";

import useHotelSearchCondition from "@/hooks/useHotelSearchCondition";

const useHotelLink = () => {
  const { condition } = useHotelSearchCondition("hotel");

  function formatDate(date) {
    return dayjs(date).format("MM/DD/YYYY");
  }

  const getHotelLink = (data: any) => {
    let hotel_link: string | undefined;
    const hotel_search = condition.startDate && condition.endDate;
    if (hotel_search) {
      const checkinDate = condition.startDate
        ? dayjs(condition.startDate).format("YYYY-MM-DD")
        : "---";
      let checkoutDate = condition.endDate ? dayjs(condition.endDate).format("YYYY-MM-DD") : "----"; // format YYYY-MM-DD
      // If checkin date is the same as checkout date, add 1 day to checkout date
      if (checkinDate === checkoutDate) {
        checkoutDate = dayjs(checkinDate).add(1, "day").format("YYYY-MM-DD");
      }

      const id = data.id.split("_")[1];
      const HOTEL_LINK: { [key: string]: string } = {
        hyatt: `https://www.hyatt.com/shop/rooms/${id}?checkinDate=${checkinDate}&checkoutDate=${checkoutDate}&rooms=1&adults=2&kids=0&rate=Standard&corp_id=&rateFilter=woh`,
        // ihg: `https://www.ihg.com/hotels/us/en/find-hotels/select-roomrate?qSlH=NYCLF&qAdlt=2&qRms=1&qCiD=${checkinDate.split('-')[2]}&qCoD=${checkoutDate.split('-')[2]}&qPt=POINTS&qCpid=&qCiMy=${checkinDate.split('-')[1]}${checkinDate.split('-')[0].slice(-2)}&qCoMy=${checkoutDate.split('-')[1]}${checkoutDate.split('-')[0].slice(-2)}&qDest=%20%20%20&qRtP=${id}`,
        ihg: `https://www.ihg.com/hotels/us/en/find-hotels/select-roomrate?qDest=United%20States&qPt=POINTS&qCiD=${dayjs(
          checkinDate
        ).format("D")}&qCoD=${dayjs(checkoutDate).format("D")}&qCiMy=${dayjs(checkinDate).format(
          "YYYYMM"
        )}&qCoMy=${dayjs(checkoutDate).format(
          "YYYYMM"
        )}&qAdlt=2&qChld=0&qRms=1&qRtP=IVANI&qAAR=6CBARC&qSlH=MLEMM&qAkamaiCC=US&srb_u=1&qExpndSrch=false&qSrt=sAV&qBrs=6c.hi.ex.sb.ul.ic.cp.cw.in.vn.cv.rs.ki.ma.sp.va.sp.re.vx.nd.ii.sx.we.lx.sn&qWch=0&qSmP=0&qRad=30&qRdU=mi&setPMCookies=false&qpMbw=0&qpMn=0&qLoSe=false&qRmFltr=&qChAge=`,
        // ihg: `https://www.ihg.com/hotels/us/en/find-hotels`,
        marriott: `https://www.marriott.com/reservation/availabilitySearch.mi?fromDate=${encodeURIComponent(
          formatDate(checkinDate)
        )}&toDate=${encodeURIComponent(
          formatDate(checkoutDate)
        )}&numberOfRooms=1&numberOfAdults=2&guestCountBox=2+Adults+Per+Room&childrenCountBox=0+Children+Per+Room&roomCountBox=1+Rooms&childrenCount=0&clusterCode=none&isHwsGroupSearch=true&propertyCode=${id}&useRewardsPoints=true&flexibleDateSearch=false&showFullPrice=true&corporateCode=`,
        hilton: `https://www.hilton.com/en/book/reservation/rooms/?ctyhocn=${id}&arrivalDate=${checkinDate}&departureDate=${checkoutDate}&redeemPts=true&room1NumAdults=2`,
      };
      hotel_link = HOTEL_LINK[data.brand];
      // console.log("hotel_link: ", HOTEL_LINK["ihg"], dayjs(checkinDate).format("D"))
    }

    return hotel_link;
  };

  return {
    getHotelLink,
  };
};

export default useHotelLink;
